module.exports = __webpack_public_path__ + "static/banner_1-fb529a73b80448e34d1cbfa72e9a68df.png";